import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './laser-cutting-10kw/HeroSection';
import { EfficiencySection } from './laser-cutting-10kw/EfficiencySection';
import { ROISection } from './laser-cutting-10kw/ROISection';
import { BodorLeadsSection } from './laser-cutting-10kw/BodorLeadsSection';
export function LaserCutting10kWPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3196">
      <SeoBar data-id="element-3197" />
      <Header data-id="element-3198" />
      <main className="flex-grow" data-id="element-3199">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3200">
          <HeroSection data-id="element-3201" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-3202">
            <EfficiencySection data-id="element-3203" />
            <ROISection data-id="element-3204" />
            <BodorLeadsSection data-id="element-3205" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3206" />
    </div>;
}